import React from "react";

function renderCellValue(value) {
  if (value === null || value === undefined || value === "") {
    return "\u2014";
  }
  return String(value);
}

export default function StructuredTableRenderer({ table, darkMode = false }) {
  if (!table || !Array.isArray(table.columns) || table.columns.length === 0) {
    return null;
  }

  const rows = Array.isArray(table.display_rows) && table.display_rows.length > 0
    ? table.display_rows
    : Array.isArray(table.rows)
      ? table.rows
      : [];

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="my-4">
      {table.title && (
        <div className={`mb-2 text-sm font-semibold ${darkMode ? "text-gray-200" : "text-gray-800"}`}>
          {table.title}
        </div>
      )}

      <div className={`overflow-x-auto rounded-xl border ${darkMode ? "border-gray-700 bg-[#1f1f1f]" : "border-gray-200 bg-white"}`}>
        <table className="min-w-full border-collapse text-sm">
          <thead className={darkMode ? "bg-[#2b2b2b]" : "bg-gray-50"}>
            <tr>
              {table.columns.map((column) => (
                <th
                  key={column.key}
                  className={`px-4 py-3 text-xs font-semibold uppercase tracking-wide ${
                    column.align === "right" ? "text-right" : "text-left"
                  } ${darkMode ? "text-gray-300" : "text-gray-600"}`}
                >
                  {column.label || column.key}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, rowIndex) => (
              <tr
                key={`row-${rowIndex}`}
                className={`border-t ${darkMode ? "border-gray-700" : "border-gray-100"} ${
                  rowIndex % 2 === 0
                    ? (darkMode ? "bg-[#1f1f1f]" : "bg-white")
                    : (darkMode ? "bg-[#252525]" : "bg-gray-50/60")
                }`}
              >
                {table.columns.map((column) => (
                  <td
                    key={`${rowIndex}-${column.key}`}
                    className={`px-4 py-3 align-top ${
                      column.align === "right" ? "text-right tabular-nums" : "text-left"
                    } ${darkMode ? "text-gray-200" : "text-gray-800"}`}
                  >
                    <div className="min-w-[80px] whitespace-nowrap">
                      {renderCellValue(row[column.key])}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>

          {table.totals_row && Object.keys(table.totals_row).length > 0 && (
            <tfoot>
              <tr className={`border-t-2 ${darkMode ? "border-gray-600 bg-[#2b2b2b]" : "border-gray-300 bg-gray-100"}`}>
                {table.columns.map((column) => (
                  <td
                    key={`total-${column.key}`}
                    className={`px-4 py-3 font-semibold ${
                      column.align === "right" ? "text-right tabular-nums" : "text-left"
                    } ${darkMode ? "text-gray-100" : "text-gray-900"}`}
                  >
                    {renderCellValue(table.totals_row[column.key])}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
